/**
 * Web/Electron only — login glass card → menu / messages / footer morph.
 *
 * Disable (pick one):
 * 1. Set LOGIN_GLASS_SPLIT_KILL_SWITCH to false below
 * 2. Set EXPO_PUBLIC_LOGIN_GLASS_SPLIT=0 in env / .env
 *
 * When disabled, Auth → Dashboard still uses the existing LoginArt curtain.
 */

/** Instant kill switch — set to `false` to turn off the morph. */
export const LOGIN_GLASS_SPLIT_KILL_SWITCH = true;

export const LOGIN_GLASS_SPLIT_ENABLED =
  LOGIN_GLASS_SPLIT_KILL_SWITCH &&
  !(
    typeof process !== 'undefined' &&
    process.env?.EXPO_PUBLIC_LOGIN_GLASS_SPLIT === '0'
  );

/** Delay before morph starts (stacked panels at source rect). */
export const GLASS_SPLIT_HOLD_MS = 40;

/** Morph duration for 1 → 3 panels. */
export const GLASS_SPLIT_MORPH_MS = 560;

/**
 * Never fade before this — morph must finish and settle even if Dashboard
 * signals ready early (warm cache).
 */
export const GLASS_SPLIT_MIN_VISIBLE_MS = 700;

/** Extra beat after Dashboard signals ready so chrome can paint under us. */
export const GLASS_SPLIT_POST_READY_MS = 180;

/** CSS fade-out duration before unmount. */
export const GLASS_SPLIT_FADE_MS = 320;

/** Safety: force fade even if Dashboard never signals (chunk hang). */
export const GLASS_SPLIT_MAX_MS = 4500;
